<template>
  <div class="registros">
    <!-- Puente CX: importar / exportar -->
    

    <!-- Mensaje -->
    <div
      v-if="msg"
      class="msg"
      :style="{ background: msgBg, color: msgColor }"
    >
      <PortalIcon :name="msgIcon" :size="16" />
      <span>{{ msg.texto }}</span>
      <button class="msg-close" @click="msg = null">
        <PortalIcon name="X" :size="16" />
      </button>
    </div>

    <!-- Filtros -->
    <div class="filtros">
      <div class="search">
        <PortalIcon name="Search" :size="15" style="color: var(--pt-muted)" />
        <input
          v-model="q"
          placeholder="Buscar cliente, asunto o folio…"
          class="search-inp"
        />
      </div>
      <select v-model="fCliente" class="select" title="Filtrar por cliente">
        <option v-for="c in clientes" :key="c">{{ c }}</option>
      </select>
      <select v-model="fArea" class="select">
        <option v-for="a in areas" :key="a">{{ a }}</option>
      </select>
      <select v-model="fEstatus" class="select">
        <option v-for="e in ['Todos', ...ESTATUS]" :key="e">{{ e }}</option>
      </select>
      <select v-model="fPrioridad" class="select" title="Filtrar por prioridad">
        <option v-for="p in prioridades" :key="p">{{ p }}</option>
      </select>
      <button v-if="!esGerenteArea" class="nuevo" @click="modal = true">
        <PortalIcon name="Plus" :size="16" /> Nuevo
      </button>
    </div>

    <!-- Tabla -->
    <div class="tabla-wrap">
      <div class="tabla-scroll">
        <table class="tabla">
          <thead>
            <tr class="th-row">
              <th>Folio</th>
              <th>Cliente / Asunto</th>
              <th>Área</th>
              <th>Prioridad</th>
              <th>Estatus / Avance</th>
              <th>Compromiso</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="r in filtrados"
              :key="r.id"
              class="tr"
              title="Ver detalle de la solicitud"
              @click="abrirDetalle(r)"
            >
              <td class="td-folio">{{ r.folio }}</td>
              <td class="td-asunto">
                <div class="cliente">{{ r.cliente }}</div>
                <div class="asunto">{{ r.asunto }}</div>
                <div class="meta">
                  {{ r.categoria }}{{ r.canal ? " · " + r.canal : "" }}
                </div>
              </td>
              <td>
                <PortalBadge :text="r.area" :color="colorArea(r.area)" />
              </td>
              <td>
                <span
                  class="prio"
                  :style="{ color: PRIORIDAD_COLOR[r.prioridad] || '#64748b' }"
                >
                  {{ r.prioridad }}
                </span>
              </td>
              <td>
                <template v-if="esGerenteArea">
                  <span
                    class="prio"
                    :style="{ color: ESTATUS_COLOR[normEstatus(r.estatus)] || '#64748b' }"
                  >{{ normEstatus(r.estatus) }}</span>
                  <button
                    v-if="puedeDeclinar(r)"
                    class="declinar"
                    :disabled="estatusBusy === r.id"
                    @click.stop="declinar(r)"
                  >
                    Declinar
                  </button>
                </template>
                <template v-else>
                  <select
                    :key="'est-' + r.id + '-' + estatusResetKey"
                    class="estatus-sel"
                    :value="normEstatus(r.estatus)"
                    :disabled="estatusBusy === r.id"
                    :style="{
                      color: ESTATUS_COLOR[normEstatus(r.estatus)],
                      background: ESTATUS_COLOR[normEstatus(r.estatus)] + '1a',
                    }"
                    @click.stop
                    @change="cambiarEstatus(r, $event.target.value)"
                  >
                    <option v-for="e in ESTATUS" :key="e" :value="e">{{ e }}</option>
                  </select>
                  <div class="avance-track">
                    <div
                      class="avance-fill"
                      :style="{ width: r._av + '%', background: colorArea(r.area) }"
                    ></div>
                  </div>
                </template>
              </td>
              <td>
                <span class="sla" :style="{ color: SLA_COLOR[r._sla] || '#64748b' }">
                  <PortalIcon
                    v-if="r._sla === 'Vencido'"
                    name="AlertTriangle"
                    :size="12"
                  />
                  <PortalIcon
                    v-else-if="r._sla === 'Por vencer'"
                    name="Clock"
                    :size="12"
                  />
                  {{ r._sla }}
                </span>
                <div class="sla-fecha">
                  {{ r.fechaCompromiso ? fmt(r.fechaCompromiso) : "sin fecha" }}
                </div>
              </td>
              <td class="td-del">
                <!-- Flujo natural de Fase 4: del hallazgo nace el plan de acción.
                     Requiere idClaim del backend para la llave foránea. -->
                <button
                  v-if="!esGerenteArea"
                  class="plan"
                  :title="
                    r.idClaim
                      ? 'Crear plan de acción para esta incidencia'
                      : 'Sin folio del backend: no se puede crear un plan'
                  "
                  :disabled="!r.idClaim"
                  @click.stop="nuevoPlan = r"
                >
                  <PortalIcon name="Flag" :size="14" /> Plan
                </button>
                <button
                  v-if="!esGerenteArea"
                  class="del"
                  :title="r.folioServer ? 'Eliminar' : 'Sin folio: no se puede eliminar'"
                  :disabled="!r.folioServer"
                  @click.stop="pedirEliminar(r)"
                >
                  <PortalIcon name="X" :size="15" />
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div v-if="filtrados.length === 0" class="empty">
        No hay registros con estos filtros.
      </div>
    </div>

    <NuevoRegistroModal
      v-if="modal"
      :busy="crearBusy"
      :error="crearError"
      @close="cerrarModal"
      @crear="onCrear"
    />

    <!-- Detalle / edición de una incidencia -->
    <DetalleRegistroModal
      v-if="detalle"
      :registro="detalle"
      :rol="rol"
      @close="detalle = null"
      @actualizar="onActualizar"
    />

    <!-- Alta de plan de acción a partir de la incidencia (Fase 4) -->
    <NuevoPlanModal
      v-if="nuevoPlan"
      :claim="nuevoPlan"
      :busy="planBusy"
      :error="planError"
      @close="cerrarNuevoPlan"
      @crear="onCrearPlan"
    />

    <!-- Confirmación de eliminación -->
    <AlertDialog
      v-if="confirmDel"
      variant="warn"
      title="Eliminar incidencia"
      :message="`¿Eliminar la incidencia ${confirmDel.folio} (${confirmDel.cliente})? Esta acción no se puede deshacer.`"
      confirm-text="Eliminar"
      cancel-text="Cancelar"
      @confirm="eliminarConfirmado"
      @close="confirmDel = null"
    />

    <!-- Notificación (resultado del servicio) -->
    <AlertDialog
      v-if="alerta"
      :variant="alerta.variant"
      :title="alerta.title"
      :message="alerta.message"
      @close="alerta = null"
    />
  </div>
</template>

<script>
import PortalIcon from "./PortalIcon.vue";
import PortalBadge from "./PortalBadge.vue";
import NuevoRegistroModal from "./NuevoRegistroModal.vue";
import DetalleRegistroModal from "./DetalleRegistroModal.vue";
import NuevoPlanModal from "./NuevoPlanModal.vue";
import AlertDialog from "./AlertDialog.vue";
import portalService from "../../../services/portal.service";
import cxService from "../../../services/cx.service";
import { esGerenteArea } from "./cx.rules";
import {
  ESTATUS,
  ESTATUS_COLOR,
  PRIORIDAD_COLOR,
  SLA_COLOR,
} from "./portal.constants";
import {
  normEstatus,
  colorArea,
  fmt,
  exportJSON,
  exportCSV,
  leerMatrizExcel,
} from "./portal.helpers";

export default {
  name: "RegistrosTab",
  components: {
    PortalIcon,
    PortalBadge,
    NuevoRegistroModal,
    DetalleRegistroModal,
    NuevoPlanModal,
    AlertDialog,
  },
  props: {
    reg: { type: Array, default: () => [] },
  },
  emits: ["update-estatus", "import", "data-updated"],
  data() {
    return {
      ESTATUS,
      ESTATUS_COLOR,
      PRIORIDAD_COLOR,
      SLA_COLOR,
      fCliente: "Todos",
      fArea: "Todas",
      fEstatus: "Todos",
      fPrioridad: "Todas",
      q: "",
      modal: false,
      detalle: null, // incidencia abierta en el modal de detalle
      estatusBusy: null, // id de la incidencia cuyo PUT de estatus está en curso
      estatusResetKey: 0, // fuerza el re-render del <select> para revertir si falla
      msg: null,
      crearBusy: false,
      crearError: "",
      confirmDel: null, // incidencia pendiente de confirmar eliminación
      alerta: null, // { variant, title, message }
      nuevoPlan: null, // incidencia desde la que se está creando un plan
      planBusy: false,
      planError: "",
      sesion: {},
    };
  },
  computed: {
    rol() {
      return (this.sesion && this.sesion.rol) || "";
    },
    esGerenteArea() {
      return esGerenteArea(this.rol);
    },
    clientes() {
      return [
        "Todos",
        ...Array.from(new Set(this.reg.map((r) => r.cliente).filter(Boolean))).sort(
          (a, b) => a.localeCompare(b, "es")
        ),
      ];
    },
    areas() {
      return ["Todas", ...Array.from(new Set(this.reg.map((r) => r.area)))];
    },
    prioridades() {
      return [
        "Todas",
        ...Array.from(new Set(this.reg.map((r) => r.prioridad).filter(Boolean))),
      ];
    },
    filtrados() {
      return this.reg.filter((r) => {
        if (this.fCliente !== "Todos" && r.cliente !== this.fCliente) return false;
        if (this.fArea !== "Todas" && r.area !== this.fArea) return false;
        if (this.fEstatus !== "Todos" && normEstatus(r.estatus) !== this.fEstatus)
          return false;
        if (this.fPrioridad !== "Todas" && r.prioridad !== this.fPrioridad)
          return false;
        if (
          this.q &&
          !`${r.folio} ${r.cliente} ${r.asunto}`
            .toLowerCase()
            .includes(this.q.toLowerCase())
        )
          return false;
        return true;
      });
    },
    msgBg() {
      if (!this.msg) return "";
      return this.msg.tipo === "ok"
        ? "#dcfce7"
        : this.msg.tipo === "info"
        ? "#e0f2fe"
        : "#fee2e2";
    },
    msgColor() {
      if (!this.msg) return "";
      return this.msg.tipo === "ok"
        ? "#166534"
        : this.msg.tipo === "info"
        ? "#075985"
        : "#991b1b";
    },
    msgIcon() {
      if (!this.msg) return "Info";
      return this.msg.tipo === "ok"
        ? "CheckCircle2"
        : this.msg.tipo === "info"
        ? "Clock"
        : "AlertTriangle";
    },
  },
  async created() {
    this.sesion = await cxService.sesion().catch(() => ({}));
  },
  methods: {
    normEstatus,
    colorArea,
    fmt,
    exportJSON,
    exportCSV,
    cerrarModal() {
      if (this.crearBusy) return;
      this.modal = false;
      this.crearError = "";
    },
    cerrarNuevoPlan() {
      if (this.planBusy) return;
      this.nuevoPlan = null;
      this.planError = "";
    },
    // Crea el plan de acción de esta incidencia (Fase 4). El seguimiento
    // posterior vive en la pestaña "Planes de acción".
    async onCrearPlan(form) {
      this.planBusy = true;
      this.planError = "";
      try {
        const r = await cxService.crearPlan(form);
        this.nuevoPlan = null;
        this.alerta = {
          variant: "success",
          title: "Plan de acción creado",
          message:
            "Se creó el plan " +
            r.folio +
            " y se notificó al responsable. Dale seguimiento en la pestaña “Planes de acción”.",
        };
      } catch (e) {
        this.planError = e.message;
      } finally {
        this.planBusy = false;
      }
    },
    // Cambia el estatus desde el <select> de la lista vía PUT real.
    // Ante error revierte el <select> (bump de key) y avisa al usuario.
    async cambiarEstatus(r, estatus) {
      if (this.estatusBusy) return;
      this.estatusBusy = r.id;
      try {
        const list = await portalService.updateEstatus(r.id, estatus);
        this.$emit("data-updated", list);
        this.msg = { tipo: "ok", texto: `Estatus actualizado a “${estatus}”.` };
      } catch (e) {
        this.estatusResetKey++; // revierte el <select> al valor anterior
        this.alerta = {
          variant: "error",
          title: "Error al actualizar estatus",
          message:
            "No se pudo actualizar el estatus. " +
            (e && e.message ? e.message : ""),
        };
      } finally {
        this.estatusBusy = null;
      }
    },
    // Abre el detalle de la incidencia seleccionada.
    abrirDetalle(r) {
      this.detalle = r;
    },
    // El gerente de área solo puede "declinar" la incidencia (no avance ni cierre).
    puedeDeclinar(r) {
      const e = normEstatus(r.estatus);
      return e !== "Concluido" && e !== "Declinado";
    },
    declinar(r) {
      return this.cambiarEstatus(r, "Declinado");
    },
    // Edita la incidencia vía PUT real (/incidencias/{folio}/editar). Actualiza
    // la caché del servicio y refresca la lista del padre. Muestra el mensaje del
    // servicio en éxito y un alert en error.
    async onActualizar(payload) {
      const { id, ...patch } = payload;
      try {
        const { list, mensaje } = await portalService.updateRegistro(id, patch);
        this.$emit("data-updated", list);
        this.detalle = null;
        this.msg = { tipo: "ok", texto: mensaje };
      } catch (e) {
        this.alerta = {
          variant: "error",
          title: "Error al editar",
          message:
            "No se pudo editar la incidencia. " +
            (e && e.message ? e.message : ""),
        };
      }
    },
    // Crea la incidencia vía POST real; muestra estado y errores en el modal
    // y emite la lista actualizada al padre cuando el alta es correcta.
    async onCrear(form) {
      this.crearBusy = true;
      this.crearError = "";
      try {
        const list = await portalService.createRegistro(form);
        this.$emit("data-updated", list);
        this.modal = false;
        this.msg = { tipo: "ok", texto: "Incidencia creada correctamente." };
      } catch (e) {
        this.crearError =
          "No se pudo crear la incidencia. " + (e && e.message ? e.message : "");
      } finally {
        this.crearBusy = false;
      }
    },
    // Abre la confirmación de eliminación (requiere folio real del backend).
    pedirEliminar(r) {
      if (!r.folioServer) {
        this.alerta = {
          variant: "error",
          title: "No disponible",
          message: "Esta incidencia no tiene folio y no puede eliminarse.",
        };
        return;
      }
      this.confirmDel = r;
    },
    // Ejecuta el DELETE y notifica el resultado con un AlertDialog.
    async eliminarConfirmado() {
      const item = this.confirmDel;
      this.confirmDel = null;
      if (!item) return;
      try {
        const { list, mensaje } = await portalService.deleteRegistro(
          item.folioServer
        );
        this.$emit("data-updated", list);
        this.alerta = {
          variant: "success",
          title: "Incidencia eliminada",
          message: mensaje,
        };
      } catch (e) {
        this.alerta = {
          variant: "error",
          title: "Error al eliminar",
          message:
            "No se pudo eliminar la incidencia. " + (e && e.message ? e.message : ""),
        };
      }
    },
    async importar(e) {
      const file = e.target.files && e.target.files[0];
      if (!file) return;
      this.msg = { tipo: "info", texto: "Leyendo archivo…" };
      try {
        let nuevos = [];
        if (/\.(xlsx|xls)$/i.test(file.name)) {
          nuevos = await leerMatrizExcel(file);
        } else {
          const txt = await file.text();
          const p = JSON.parse(txt);
          nuevos = Array.isArray(p) ? p : p.registros || [];
        }
        if (!nuevos.length) {
          this.msg = {
            tipo: "err",
            texto: "No se encontraron registros válidos en el archivo.",
          };
          e.target.value = "";
          return;
        }
        this.$emit("import", nuevos);
        this.msg = {
          tipo: "ok",
          texto: `Se procesaron ${nuevos.length} registros de la matriz.`,
        };
      } catch (err) {
        this.msg = {
          tipo: "err",
          texto:
            "No se pudo leer el archivo. Usa el Excel de la matriz o un JSON del puente.",
        };
      }
      e.target.value = "";
    },
  },
};
</script>

<style scoped>
.registros {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

/* Puente CX */
.puente {
  background: var(--pt-card);
  border: 1px solid var(--pt-border);
  border-radius: 16px;
  padding: 14px;
}
.puente-title {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-size: 12px;
  font-weight: 700;
  color: var(--pt-text);
}
.puente-actions {
  display: inline-flex;
  gap: 8px;
  flex-wrap: wrap;
  float: right;
}
.pbtn {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 6px 12px;
  border-radius: 8px;
  font-size: 12px;
  font-weight: 600;
  cursor: pointer;
  background: var(--pt-card);
  color: var(--pt-dim);
  border: 1px solid var(--pt-border);
}
.pbtn.primary {
  background: #e7eefb;
  color: #003ca5;
  border-color: transparent;
}
.hidden-file {
  display: none;
}
.puente-hint {
  clear: both;
  display: flex;
  align-items: flex-start;
  gap: 6px;
  font-size: 12px;
  color: var(--pt-muted);
  margin: 8px 0 0;
}

/* Mensaje */
.msg {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 14px;
  padding: 10px 16px;
  border-radius: 8px;
}
.msg-close {
  margin-left: auto;
  background: none;
  border: 0;
  cursor: pointer;
  opacity: 0.6;
  color: inherit;
}

/* Filtros */
.filtros {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px;
}
.search {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 12px;
  border-radius: 8px;
  flex: 1;
  min-width: 180px;
  background: var(--pt-card);
  border: 1px solid var(--pt-border);
}
.search-inp {
  background: transparent;
  border: 0;
  outline: none;
  color: var(--pt-text);
  font-size: 14px;
  width: 100%;
  font-family: inherit;
}
.select {
  padding: 8px 12px;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 500;
  background: var(--pt-card);
  color: var(--pt-text);
  border: 1px solid var(--pt-border);
  outline: none;
  font-family: inherit;
}
.nuevo {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 8px 16px;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 600;
  color: #fff;
  background: #003ca5;
  border: 0;
  cursor: pointer;
}

/* Tabla */
.tabla-wrap {
  background: var(--pt-card);
  border: 1px solid var(--pt-border);
  border-radius: 16px;
  overflow: hidden;
}
.tabla-scroll {
  overflow-x: auto;
}
.tabla {
  width: 100%;
  min-width: 880px;
  border-collapse: collapse;
  font-size: 14px;
}
.th-row th {
  text-align: left;
  font-size: 12px;
  text-transform: uppercase;
  color: var(--pt-muted);
  font-weight: 600;
  padding: 12px;
  border-bottom: 1px solid var(--pt-border);
}
.tr {
  cursor: pointer;
}
.tr:hover td {
  background: var(--pt-elev);
}
.tr td {
  padding: 12px;
  vertical-align: top;
  border-bottom: 1px solid var(--pt-line);
}
.td-folio {
  font-weight: 600;
  font-variant-numeric: tabular-nums;
}
.td-asunto {
  max-width: 320px;
}
.cliente {
  color: var(--pt-text);
  font-weight: 500;
}
.asunto {
  color: var(--pt-dim);
  font-size: 12px;
}
.meta {
  color: var(--pt-muted);
  font-size: 11px;
  margin-top: 2px;
}
.prio {
  font-size: 12px;
  font-weight: 600;
}
.estatus-sel {
  font-size: 12px;
  font-weight: 600;
  border-radius: 6px;
  padding: 4px 8px;
  border: none;
  outline: none;
  cursor: pointer;
}
.avance-track {
  margin-top: 6px;
  height: 6px;
  width: 92px;
  border-radius: 999px;
  overflow: hidden;
  background: var(--pt-track);
}
.avance-fill {
  height: 100%;
  border-radius: 999px;
}
.sla {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  font-size: 12px;
  font-weight: 600;
}
.sla-fecha {
  color: var(--pt-muted);
  font-size: 11px;
  margin-top: 2px;
}
.td-del {
  text-align: right;
  white-space: nowrap;
}
.plan {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 4px 9px;
  margin-right: 4px;
  border-radius: 6px;
  font-size: 12px;
  font-weight: 600;
  background: #e7eefb;
  color: #003ca5;
  border: 0;
  cursor: pointer;
  font-family: inherit;
}
.plan:disabled {
  cursor: default;
  opacity: 0.35;
}
.del {
  background: none;
  border: 0;
  cursor: pointer;
  color: var(--pt-muted);
}
.del:hover {
  color: #dc2626;
}
.del:disabled {
  cursor: default;
  opacity: 0.35;
}
.del:disabled:hover {
  color: var(--pt-muted);
}
.declinar {
  display: inline-block;
  margin-left: 8px;
  padding: 4px 10px;
  border-radius: 6px;
  font-size: 12px;
  font-weight: 600;
  background: #fee2e2;
  color: #991b1b;
  border: 0;
  cursor: pointer;
  font-family: inherit;
}
.declinar:disabled {
  cursor: default;
  opacity: 0.5;
}
.empty {
  text-align: center;
  font-size: 14px;
  color: var(--pt-muted);
  padding: 32px 0;
}
</style>
